<template>
  <div id="mng-topics">

    <!-- add- / edit-valinta -->
    <div class="flex justify-around pb-4">
      <button
        v-for="mode in modes"
        :key="mode.mode"
        @click="toggleMode(mode.mode)"
        class="btn"
        :class="{ 'btn-empty': mode.mode !== currentMode }"
      >{{ mode.text }}</button>
    </div>

    <!-- aihelista / olemassa olevat aiheet (EDIT) -->
    <div v-if="currentMode === 'edit'" class="form-field mt-0 mb-4">
      <label for="is-topic">tallennetut aiheet</label>
      <select name="is-topic" v-model="isTopic" v-on:change="onChange" class="rounded-5 color-grey">
        <option v-for="(topic, index) in topics" :key="index" class="color-black">{{ topic.title }}</option>
      </select>
    </div>

    <!-- poista itemi firestoresta -->
    <div v-if="isTopic" class="flex justify-center mb-4">
      <div @click="deleteConfirm = true" class="i-flex align-center txt-center font-8 pointer">
        <span class="color-grey">Poista aihe tietokannasta</span>
        <i class="material-icons ml-1 color-grey-l1">delete</i>
      </div>
    </div>
    <!-- poista itemi firestoresta -modal -->
    <div v-if="deleteConfirm" class="fixed tl-0 br-0 flex flex-center" style="background-color: rgba(0, 0, 0, 0.3);">
      <div class="card i-block px-10 py-14 txt-center">
        <p class="font-10 txt-bold">Oletko täysin varma että haluat jatkaa?</p>
        <button @click.prevent="deleteConfirm = false" class="btn block mx-auto mt-4">Peruuta</button>
        <p class="mt-4 font-10">Tehdyt muutokset eivät ole peruttavissa</p>
        <button @click.prevent="confirmDeleteFromDb" class="btn btn-3 block mx-auto mt-8" style="background-color: red;">Poista</button>
        <p>{{ this.deleteConfirmFeedback }}</p>
      </div>
    </div>

    <!-- lomakkeen otsikko -->
    <hr class="border-0 border-t-l1 mb-1">
    <div class="flex justify-between">
      <h2 v-if="currentMode === 'add'" class="mb-5 txt-bold">Aiheen lisäys</h2>
      <h2 v-else class="mb-5 txt-bold">Aiheen muokkaus</h2>
      <i @click="showModal = true" class="material-icons color-grey-l1 font-10 pt-1">help</i>
    </div>

    <!-- tekstin editoinitohjeet - modal -->
    <portal to="modals" v-if="showModal">
      <modal-html-guide
        :show="showModal"
        @close="showModal = false"
      ></modal-html-guide>
    </portal>

    <form @submit.prevent>

      <!-- aiheen nimi -->
      <div class="form-field" :class="{ required: isRequired }">
        <label for="title">Otsikko</label>
        <input type="text" name="title" v-model="title">
      </div>

      <!-- tekijät / "authors" -->
      <div class="form-field">
        <label for="author">Tekijä(t)</label>
        <input type="text" name="author" v-model="author">
      </div>

      <!-- johdanto (teksti) -->
      <div class="form-field">
        <label for="topic-intro">Johdanto</label>
        <textarea name="topic-intro" rows="4" v-model="teaser"></textarea>
      </div>

      <!-- tekstisisältö (pääteksti) -->
      <div class="form-field" :class="{ required: isRequired }">
        <label for="main-info">Tekstisisältö</label>
        <textarea name="main-info" rows="6" v-model="mainInfo"></textarea>
      </div>

      <!-- widgetin valinta (radio) -->
      <div class="form-field mb-5">
        <label class="mb-2">Sisällön esitystapa</label>
        <div>
          <div class="flex align-center mb-1">
            <input type="radio" value="default" v-model="RADIO" class="mr-1">
            <label for="topic-widgets">Ei erityisrakennetta</label>
          </div>
          <div class="flex align-center mb-1">
            <input type="radio" value="four" v-model="RADIO" class="mr-1">
            <label for="topic-widgets">4-kenttä</label>
          </div>
          <div class="flex align-center">
            <input type="radio" value="many" v-model="RADIO" class="mr-1">
            <label for="topic-widgets">Ala-aiheet (max 10kpl)</label>
          </div>
        </div>
      </div>

      <hr v-if="RADIO === 'four' || RADIO === 'many'" class="border-0 border-t-l2 mb-2">

      <!-- nelikenttö (radio = four) -->
      <div v-if="RADIO === 'four'" class="form-field four-radios" :class="{ required: isRequired }">
        <h4 class="mb-2 font-8 txt-bold">Nelikentän akselit / määritteet:</h4>

        <!-- nelikentän akseleiden määrittäminen -->
        <div>
          <label for="four-top">Y-akseli: ylä</label>
          <input v-model="fourDescrTop" type="text">
        </div>
        <div>
          <label for="four-bottom">Y-akseli: ala</label>
          <input v-model="fourDescrBottom" type="text">
        </div>
        <div>
          <label for="four-left">X-akseli: vasen</label>
          <input v-model="fourDescrLeft" type="text">
        </div>
        <div>
          <label for="four-right">X-akseli: oikea</label>
          <input v-model="fourDescrRight" type="text">
        </div>

        <h4 class="mt-4 mb-2 font-8 txt-bold">Nelikentän aiheet ja sisältö:</h4>

        <!-- nelikentän kenttien määrittäminen -->
        <div>
          <label for="fourMainInfo1">Aihe 1 <span class="color-grey">(nelikenttä: vas-ylä)</span></label>
          <input v-model="fourHeader1" type="text" placeholder="otsikko">
          <textarea name="fourMainInfo1" rows="4" v-model="fourMainInfo1" placeholder="teksti"></textarea>
        </div>
        <div>
          <label for="fourMainInfo2">Aihe 2 <span class="color-grey">(nelikenttä: oik-ylä)</span></label>
          <input v-model="fourHeader2" type="text" placeholder="otsikko">
          <textarea name="fourMainInfo2" rows="4" v-model="fourMainInfo2" placeholder="teksti"></textarea>
        </div>
        <div>
          <label for="fourMainInfo3">Aihe 3 <span class="color-grey">(nelikenttä: vas-ala)</span></label>
          <input v-model="fourHeader3" type="text" placeholder="otsikko">
          <textarea name="fourMainInfo3" rows="4" v-model="fourMainInfo3" placeholder="teksti"></textarea>
        </div>
        <div>
          <label for="fourMainInfo4">Aihe 4 <span class="color-grey">(nelikenttä: oik-ala)</span></label>
          <input v-model="fourHeader4" type="text" placeholder="otsikko">
          <textarea name="fourMainInfo4" rows="4" v-model="fourMainInfo4" placeholder="teksti"></textarea>
        </div>
      </div>

      <!-- monikenttö (radio = many) -> KOVAKOODATTU :/ -->
      <div v-if="RADIO === 'many'" class="form-field many-radios" :class="{ required: isRequired }">
        <div v-if="1 <= topicCounter">
          <label for="many-main-info-1">Ala-aihe 1</label>
          <input v-model="manyHeader1" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo1" name="many-main-info-1" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="2 <= topicCounter">
          <label for="many-main-info-2">Ala-aihe 2</label>
          <input v-model="manyHeader2" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo2" name="many-main-info-2" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="3 <= topicCounter">
          <label for="many-main-info-3">Ala-aihe 3</label>
          <input v-model="manyHeader3" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo3" name="many-main-info-3" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="4 <= topicCounter">
          <label for="many-main-info-4">Ala-aihe 4</label>
          <input v-model="manyHeader4" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo4" name="many-main-info-4" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="5 <= topicCounter">
          <label for="many-main-info-5">Ala-aihe 5</label>
          <input v-model="manyHeader5" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo5" name="many-main-info-5" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="6 <= topicCounter">
          <label for="many-main-info-6">Ala-aihe 6</label>
          <input v-model="manyHeader6" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo6" name="many-main-info-6" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="7 <= topicCounter">
          <label for="many-main-info-7">Ala-aihe 7</label>
          <input v-model="manyHeader7" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo7" name="many-main-info-7" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="8 <= topicCounter">
          <label for="many-main-info-8">Ala-aihe 8</label>
          <input v-model="manyHeader8" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo8" name="many-main-info-8" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="9 <= topicCounter">
          <label for="many-main-info-9">Ala-aihe 9</label>
          <input v-model="manyHeader9" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo9" name="many-main-info-9" rows="4" placeholder="teksti"></textarea>
        </div>
        <div v-if="10 <= topicCounter">
          <label for="many-main-info-10">Ala-aihe 10</label>
          <input v-model="manyHeader10" type="text" placeholder="alaotsikko">
          <textarea v-model="manyMainInfo10" name="many-main-info-10" rows="4" placeholder="teksti"></textarea>
        </div>
        <i @click="amountOfTopics('inc')" :class="{ noclick: topicCounter === 10 }" class="material-icons color-theme noselect mr-1">add_box</i>
        <i @click="amountOfTopics('dec')" :class="{ noclick: topicCounter === 1 }" class="material-icons color-theme noselect">indeterminate_check_box</i>
      </div>

      <!-- SUBMIT -->
      <p v-if="feedback" class="txt-center">{{ this.feedback }}</p>
      <button @click.self="addToDatabase" class="btn btn-3 block mx-auto mt-6">{{this.addOrEdit}}</button>

    </form>

  </div>
</template>

<script>
// ===================================================================================================================
import db from '@/firebase/init'
import slugify from 'slugify'
import modalHtmlGuide from '../components/modals/modalHtmlGuide'

export default {
  name: 'mngTopics',

  components: {
    modalHtmlGuide
  },

  data () {
    return {
      modes: [
        { mode: 'add', text: 'lisää' },
        { mode: 'edit', text: 'muokkaa' }
      ],
      currentMode: 'add',
      topics: [], // from created()
      isTopic: null, // from <select>
      id: null,
      title: null,
      mainInfo: null,
      author: '@Ketterä',
      isRequired: false,
      feedback: null,
      links: [],
      linkName: null,
      linkUrl: null,
      linkFeedback: null,
      deleteConfirm: false, // varmistus: itemin deletointi kannasta
      deleteConfirmFeedback: null,
      showModal: false, // tekstin editointiohjeet
      // uusimmat (KOVAKOODATTU :/)
      teaser: null,
      RADIO: 'default',
      fourDescrTop: null, // four-field ->
      fourDescrBottom: null,
      fourDescrLeft: null,
      fourDescrRight: null,
      fourHeader1: null,
      fourMainInfo1: null,
      fourHeader2: null,
      fourMainInfo2: null,
      fourHeader3: null,
      fourMainInfo3: null,
      fourHeader4: null,
      fourMainInfo4: null,
      topicCounter: 1, // many fields (max. 10kpl) ->
      manyHeader1: null,
      manyMainInfo1: null,
      manyHeader2: null,
      manyMainInfo2: null,
      manyHeader3: null,
      manyMainInfo3: null,
      manyHeader4: null,
      manyMainInfo4: null,
      manyHeader5: null,
      manyMainInfo5: null,
      manyHeader6: null,
      manyMainInfo6: null,
      manyHeader7: null,
      manyMainInfo7: null,
      manyHeader8: null,
      manyMainInfo8: null,
      manyHeader9: null,
      manyMainInfo9: null,
      manyHeader10: null,
      manyMainInfo10: null
    }
  },

  created () {
    this.getTopics()
  },

  computed: {
    addOrEdit () { // <form>:n buttonin teksti
      if (this.isTopic) {
        return 'muokkaa'
      } else {
        return 'lisää'
      }
    }
  },

  methods: {
    amountOfTopics (value) { // many topics
      if (value === 'inc') {
        if (this.topicCounter === 10) {

        } else {
          this.topicCounter++
        }
      } else {
        if (this.topicCounter === 1) {

        } else {
          this.topicCounter--
        }
      }
    },

    getTopics () { // for created()
      this.topics = []
      db.collection('aiheet').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let aihe = doc.data()
          aihe.id = doc.id // tarvitaanko?
          this.topics.push(aihe)
        })
      })
    },

    toggleMode (mode) {
      this.getTopics()

      this.currentMode = mode
      this.title = null
      this.slug = null
      this.author = '@Ketterä'
      this.mainInfo = null
      this.isTopic = null
      this.id = null
      // uusimmat ->
      this.teaser = null
      this.RADIO = 'default'
      this.fourDescrTop = null
      this.fourDescrBottom = null
      this.fourDescrLeft = null
      this.fourDescrRight = null
      this.fourHeader1 = null
      this.fourMainInfo1 = null
      this.fourHeader2 = null
      this.fourMainInfo2 = null
      this.fourHeader3 = null
      this.fourMainInfo3 = null
      this.fourHeader4 = null
      this.fourMainInfo4 = null
      this.topicCounter = 1
      this.manyHeader1 = null
      this.manyMainInfo1 = null
      this.manyHeader2 = null
      this.manyMainInfo2 = null
      this.manyHeader3 = null
      this.manyMainInfo3 = null
      this.manyHeader4 = null
      this.manyMainInfo4 = null
      this.manyHeader5 = null
      this.manyMainInfo5 = null
      this.manyHeader6 = null
      this.manyMainInfo6 = null
      this.manyHeader7 = null
      this.manyMainInfo7 = null
      this.manyHeader8 = null
      this.manyMainInfo8 = null
      this.manyHeader9 = null
      this.manyMainInfo9 = null
      this.manyHeader10 = null
      this.manyMainInfo10 = null
    },

    onChange () {
      if (this.isTopic) {
        let current = this.topics.find(topic => {
          return topic.title === this.isTopic
        })
        this.id = current.id
        this.title = current.title
        this.mainInfo = current.mainInfo
        this.author = current.author
        // uusimmat:
        if (current.RADIO) {
          this.teaser = current.teaser
          this.RADIO = current.RADIO
          this.fourDescrTop = current.fourDescrTop || null
          this.fourDescrBottom = current.fourDescrBottom || null
          this.fourDescrLeft = current.fourDescrLeft || null
          this.fourDescrRight = current.fourDescrRight || null
          this.fourHeader1 = current.fourHeader1
          this.fourMainInfo1 = current.fourMainInfo1
          this.fourHeader2 = current.fourHeader2
          this.fourMainInfo2 = current.fourMainInfo2
          this.fourHeader3 = current.fourHeader3
          this.fourMainInfo3 = current.fourMainInfo3
          this.fourHeader4 = current.fourHeader4
          this.fourMainInfo4 = current.fourMainInfo4
          this.topicCounter = current.topicCounter
          this.manyHeader1 = current.manyHeader1
          this.manyMainInfo1 = current.manyMainInfo1
          this.manyHeader2 = current.manyHeader2
          this.manyMainInfo2 = current.manyMainInfo2
          this.manyHeader3 = current.manyHeader3
          this.manyMainInfo3 = current.manyMainInfo3
          this.manyHeader4 = current.manyHeader4
          this.manyMainInfo4 = current.manyMainInfo4
          this.manyHeader5 = current.manyHeader5
          this.manyMainInfo5 = current.manyMainInfo5
          this.manyHeader6 = current.manyHeader6
          this.manyMainInfo6 = current.manyMainInfo6
          this.manyHeader7 = current.manyHeader7
          this.manyMainInfo7 = current.manyMainInfo7
          this.manyHeader8 = current.manyHeader8
          this.manyMainInfo8 = current.manyMainInfo8
          this.manyHeader9 = current.manyHeader9
          this.manyMainInfo9 = current.manyMainInfo9
          this.manyHeader10 = current.manyHeader10
          this.manyMainInfo10 = current.manyMainInfo10
        }
      }
    },

    confirmDeleteFromDb () {
      let toBeDeleted = this.topics.find(topic => {
        return topic.title === this.isTopic
      }).id
      db.collection('aiheet').doc(toBeDeleted).delete()
        .then(() => {
          this.deleteConfirmFeedback = 'Aihe poistettu tietokannasta'

          this.clearFields()
          this.getTopics()

          this.topics = this.topics.filter((theTopic) => {
            return theTopic.id !== toBeDeleted
          })
          setTimeout(() => {
            this.deleteConfirm = false
            this.deleteConfirmFeedback = null
            this.$store.dispatch('changeUpdateState', 'topics')
          }, 2000)
        })
    },

    addToDatabase () { // lisää / päivitä kohde tietokantaan
      if (this.title && this.mainInfo) {
        this.feedback = null
        this.isRequired = false
        this.slug = slugify(this.title, {
          replacement: '-',
          remove: /[$*_+~.()'"!\-:@]/g,
          lower: true
        })
        if (this.isTopic) {
          db.collection('aiheet').doc(this.id).update({
            title: this.title,
            slug: this.slug,
            mainInfo: this.mainInfo,
            author: this.author,
            // uusimmat:
            teaser: this.teaser,
            RADIO: this.RADIO,
            fourDescrTop: this.fourDescrTop,
            fourDescrBottom: this.fourDescrBottom,
            fourDescrLeft: this.fourDescrLeft,
            fourDescrRight: this.fourDescrRight,
            fourHeader1: this.fourHeader1,
            fourMainInfo1: this.fourMainInfo1,
            fourHeader2: this.fourHeader2,
            fourMainInfo2: this.fourMainInfo2,
            fourHeader3: this.fourHeader3,
            fourMainInfo3: this.fourMainInfo3,
            fourHeader4: this.fourHeader4,
            fourMainInfo4: this.fourMainInfo4,
            topicCounter: this.topicCounter,
            manyHeader1: this.manyHeader1,
            manyMainInfo1: this.manyMainInfo1,
            manyHeader2: this.manyHeader2,
            manyMainInfo2: this.manyMainInfo2,
            manyHeader3: this.manyHeader3,
            manyMainInfo3: this.manyMainInfo3,
            manyHeader4: this.manyHeader4,
            manyMainInfo4: this.manyMainInfo4,
            manyHeader5: this.manyHeader5,
            manyMainInfo5: this.manyMainInfo5,
            manyHeader6: this.manyHeader6,
            manyMainInfo6: this.manyMainInfo6,
            manyHeader7: this.manyHeader7,
            manyMainInfo7: this.manyMainInfo7,
            manyHeader8: this.manyHeader8,
            manyMainInfo8: this.manyMainInfo8,
            manyHeader9: this.manyHeader9,
            manyMainInfo9: this.manyMainInfo9,
            manyHeader10: this.manyHeader10,
            manyMainInfo10: this.manyMainInfo10
          })
            .then(() => {
              this.clearFields()

              this.feedback = 'kohde lisätty tietokantaan'
              this.isTopic = null

              this.getTopics()

              setTimeout(() => {
                this.feedback = null
                this.$store.dispatch('changeUpdateState', 'topics')
              }, 2500)
            })
        } else {
          db.collection('aiheet').add({
            title: this.title,
            slug: this.slug,
            mainInfo: this.mainInfo,
            author: this.author,
            // uusimmat:
            teaser: this.teaser,
            RADIO: this.RADIO,
            fourDescrTop: this.fourDescrTop,
            fourDescrBottom: this.fourDescrBottom,
            fourDescrLeft: this.fourDescrLeft,
            fourDescrRight: this.fourDescrRight,
            fourHeader1: this.fourHeader1,
            fourMainInfo1: this.fourMainInfo1,
            fourHeader2: this.fourHeader2,
            fourMainInfo2: this.fourMainInfo2,
            fourHeader3: this.fourHeader3,
            fourMainInfo3: this.fourMainInfo3,
            fourHeader4: this.fourHeader4,
            fourMainInfo4: this.fourMainInfo4,
            topicCounter: this.topicCounter,
            manyHeader1: this.manyHeader1,
            manyMainInfo1: this.manyMainInfo1,
            manyHeader2: this.manyHeader2,
            manyMainInfo2: this.manyMainInfo2,
            manyHeader3: this.manyHeader3,
            manyMainInfo3: this.manyMainInfo3,
            manyHeader4: this.manyHeader4,
            manyMainInfo4: this.manyMainInfo4,
            manyHeader5: this.manyHeader5,
            manyMainInfo5: this.manyMainInfo5,
            manyHeader6: this.manyHeader6,
            manyMainInfo6: this.manyMainInfo6,
            manyHeader7: this.manyHeader7,
            manyMainInfo7: this.manyMainInfo7,
            manyHeader8: this.manyHeader8,
            manyMainInfo8: this.manyMainInfo8,
            manyHeader9: this.manyHeader9,
            manyMainInfo9: this.manyMainInfo9,
            manyHeader10: this.manyHeader10,
            manyMainInfo10: this.manyMainInfo10
          })
            .then(() => {
              this.clearFields()

              this.feedback = 'kohde lisätty tietokantaan'
              this.isExample = null

              this.getTopics()

              setTimeout(() => {
                this.feedback = null
                this.$store.dispatch('changeUpdateState', 'topics')
              }, 2500)
            })
        }
      } else {
        this.feedback = 'täytä tarvittavat kentät'
        this.isRequired = true
      }
    },

    clearFields () {
      this.title = null
      this.slug = null
      this.mainInfo = null
      this.author = '@Ketterä'
      // uusimmat:
      this.teaser = null
      this.RADIO = null
      this.fourDescrTop = null
      this.fourDescrBottom = null
      this.fourDescrLeft = null
      this.fourDescrRight = null
      this.fourHeader1 = null
      this.fourMainInfo1 = null
      this.fourHeader2 = null
      this.fourMainInfo2 = null
      this.fourHeader3 = null
      this.fourMainInfo3 = null
      this.fourHeader4 = null
      this.fourMainInfo4 = null
      this.topicCounter = null
      this.manyHeader1 = null
      this.manyMainInfo1 = null
      this.manyHeader2 = null
      this.manyMainInfo2 = null
      this.manyHeader3 = null
      this.manyMainInfo3 = null
      this.manyHeader4 = null
      this.manyMainInfo4 = null
      this.manyHeader5 = null
      this.manyMainInfo5 = null
      this.manyHeader6 = null
      this.manyMainInfo6 = null
      this.manyHeader7 = null
      this.manyMainInfo7 = null
      this.manyHeader8 = null
      this.manyMainInfo8 = null
      this.manyHeader9 = null
      this.manyMainInfo9 = null
      this.manyHeader10 = null
      this.manyMainInfo10 = null
    }
  }
}
</script>

<style lang="scss">
// ===================================================================================================================
.noclick {
  pointer-events: none;
  color: rgb(200, 200, 200) !important;
}
.many-radios input, .four-radios input {
  margin-bottom: 5px;
}
</style>
